import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const masterDataSlice = createSlice({
    initialState,
    name: "master_data",
    reducers: {
        set_master_data: (state, action) => {
            if(state){
                return {
                    ...state,
                    ...action.payload
                }
            } else{
                return action.payload
            }
        },
    }
})

export default masterDataSlice.reducer;

export const {
    set_master_data,
} = masterDataSlice.actions;
